import { AccountBalance, Partner, UserDetail } from './'

export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum UserRoles {
  PARTNER_ADMIN = 'partneradmin',
  SUPERADMIN = 'superadmin',
  ADMIN = 'admin',
  FINANCE = 'finance',
  OPERATION = 'operationsupport',
}

export enum BOUserRoles {
  BO_SUPER_ADMIN = 'bosuperadmin',
  BO_ADMIN_COMPLIANCE = 'boadmincompliance',
  BO_ADMIN_FINANCE = 'boadminfinance',
  BO_ADMIN_OPERATION = 'boadminoperation',
  BO_ADMIN_TECH = 'boadmintech',
  BO_COMPLIANCE = 'bocompliance',
  BO_FINANCE = 'bofinance',
  BO_OPERATION = 'booperation',
  BO_TECH = 'botech',
}

export class User {
  constructor(
    public id: string | undefined,
    public createdTime: Date,
    public updatedTime: Date,
    public status: UserStatus,
    public email: string,
    public mobile: string,
    public name: string,
    public partnerId: string,
    public roles: UserRoles[],
    public twoFAEnabled: boolean,
    public configs: { [k: string]: any },
    public partner?: Partner,
    public accounts?: UserAccount[],
    public userDetail?: UserDetail,
  ) {}

  public static create(args: Partial<User> & Required<Pick<User, 'email' | 'mobile' | 'name' | 'partnerId'>>): User {
    return new User(
      args.id,
      args.createdTime ?? new Date(),
      args.updatedTime ?? new Date(),
      args.status ?? UserStatus.INACTIVE,
      args.email,
      args.mobile,
      args.name,
      args.partnerId,
      args.roles ?? [UserRoles.OPERATION],
      Boolean(args.twoFAEnabled),
      args.configs ?? {},
      args.partner,
    )
  }

  public hasRole: (role: string) => boolean = role => {
    return this.roles.findIndex(r => r === role) !== -1
  }
}

export class UserAccount {
  constructor(
    public id: string,
    public createdTime: string,
    public updatedTime: string,
    public userId: string,
    public currencyId: string,
    public number: string,
    public balance?: AccountBalance,
  ) {}
}
